import React from "react"; 
import {RadioButtonInput } from '../../components/FormInitiators';


const SrFixationForm2 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };


  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3>पदोन्नती पूर्व माहिती </h3>

        <label>
      01/01/2016 रोजीचा वेतनबंँड:
      <select name="payBand" value={formData.payBand} onChange={handleInputChange}>
        <option value="" disabled > -- Select an option --</option>
        <option value="S1: 4400-7440">S1: 4400-7440</option>
        <option value="PB1: 5200-20200">PB1: 5200-20200</option>
        <option value="PB2: 15600-39100">PB2: 15600-39100</option>
        <option value="PB3: 34800-60500">PB3: 34800-60500</option>
        <option value="PB4: 37400-67000">PB4: 37400-67000</option>
      </select>
      </label>

      <label>
      01/01/2016 रोजीचे वेतन बँडमध्ये वेतन:
      <input type="number" name="basicPay" value={formData.basicPay} onChange={handleInputChange}/>
      </label>


        <label>
          ०१/०१/२०१६ नंतर पदोन्नती / वरिष्ठ /निवड  लागू आहे का?
          </label>
          <label>
                <RadioButtonInput
                  value={formData.seniorScale} 
                  onChange={handleInputChange}
                  name="seniorScale"  
                  orientation="horizontal"  
                  options={[
                    { value: 'हो', label: 'हो' },
                    { value: 'नाही', label: 'नाही' }
                  ]}         
                />
            
        </label>

        <label>
      01/01/2016 रोजीचे ग्रेड वेतन:
      <input type="number" name="gradePay" value={formData.gradePay} onChange={handleInputChange}/>
      </label>


      <label>
        वॆतन बदलाचे कारण:
        <select name="reasonChange" value={formData.reasonChange} onChange={handleInputChange}>
        <option value="" disabled > -- Select an option --</option>
        <option value="पदोन्नती">पदोन्नती</option>
        <option value="वरिष्ठ वेतन श्रेणी">वरिष्ठ वेतन श्रेणी</option>
        <option value="निवड श्रेणी">निवड श्रेणी</option>
        <option value="आश्वासित प्रगती योजना लाभ -१">आश्वासित प्रगती योजना लाभ -१</option>
        <option value="आश्वासित प्रगती योजना लाभ -२">आश्वासित प्रगती योजना लाभ -२</option>
        <option value="डी एड वेतन स्तरातून बी एड वेतन स्तर मध्ये पदोन्नती">डी एड वेतन स्तरातून बी एड वेतन स्तर मध्ये पदोन्नती</option>
        <option value="ए.टी. डी . वेतन स्तरातून ए. एम . स्तरामध्ये पदोन्नती">ए.टी. डी . वेतन स्तरातून ए. एम . स्तरामध्ये पदोन्नती</option>
      </select>
      </label>
     
      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default SrFixationForm2;
